module.exports = __webpack_public_path__ + "img/Picture10.d7eb39d8.png";